import React from "react";
import { CarouselContainer } from "./styles";
import CarouselComponent from "./CarouselComponent";

const Carousel = ({ label, locale, updaterFn, ...props }) => (
  <CarouselContainer>
    <span>{label[locale]}</span>
    <CarouselComponent {...props} updateFunction={updaterFn} />
  </CarouselContainer>
);

export default Carousel;
